import { UpdateComponent } from "../../../Components/Views/UpdateComponent";
import { controllers } from "../../../Controllers/Controllers";
import { UPDATE } from "../../../DataTypes/UPDATE";

type separatorRightsType = {
    AdminComponent: any;
    UserComponent: any;
}

class RightSeparator extends UpdateComponent {
    props: separatorRightsType;
    constructor(props:separatorRightsType){
        super(props)
        this.props = props
        this.type = UPDATE.USERINFO
    }

    render(){
        const { isAdmin, isLogin } = controllers().auth
        const { AdminComponent, UserComponent  } = this.props
        if(!isLogin){
            return false
        }

        return isAdmin ? AdminComponent : UserComponent;
    }
}

export { RightSeparator }